import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import useToast from "../useToast";

export const useUpdateFightResults = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation(
    async ({ eventId, fightId, fighterResults }) => {
      const token = await getAccessTokenSilently();
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.put(
        `${apiUrl}/api/events/update-fight-results/${eventId}/${fightId}`,
        fighterResults,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("events");
        queryClient.invalidateQueries("eventDetails");
      },
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred updating fight results.";
        toast.error(errorMessage);
        console.error("Error updating fight results:", errorMessage);
      },
    }
  );
};
